import UpdateSubmissionScreen from "@/features/vendor/dashboard/application/stage/UpdateSubmissionScreen";
export default UpdateSubmissionScreen;
